const aiSix = [
  {
      "name": "Cascadeur",
      "url": "https://cascadeur.com",
      "icon": "https://cascadeur.com/favicon.ico",
      "description": "AI辅助关键帧动画制作工具，支持物理引擎和自动姿势生成，适用于游戏和影视动画。"
  },
  {
      "name": "Point-E",
      "url": "https://openai.com/index/point-e/",
      "icon": "images/rokoko.png",
      "description": "基于文本提示生成三维点云的工具，可用于创建复杂几何结构。"
  },
  {
      "name": "GET3D",
      "url": "https://research.nvidia.com/labs/toronto-ai/GET3D/",
      "icon": "images/get3d.png",
      "description": "从单张图像学习生成高质量3D纹理和形状的工具，适用于电商和虚拟现实。",
      isVpn: true
  },
  {
      "name": "3DFY AI",
      "url": "https://3dfy.ai/",
      "icon": "images/3dfy.jpg",
      "description": "多模态3D生成工具，支持文本/图像生成模型，适用于元宇宙内容创建。"
  },
  {
      "name": "DreamFusion",
      "url": "https://dreamfusion3d.github.io",
      "icon": "https://dreamfusion3d.github.io/favicon.ico",
      "description": "使用2D扩散模型将文本转换为3D场景的工具，支持多语言和文化适配。"
  },
  {
      "name": "Ponzu",
      "url": "https://www.ponzu.gg",
      "icon": "images/ponzu.png",
      "description": "AI生成无缝纹理贴图的工具，提供5种格式下载，适用于游戏美术设计。"
  },
  {
      "name": "Poly",
      "url": "https://www.polycom.com",
      "icon": "https://www.polycom.com/favicon.ico",
      "description": "智能云存储解决方案，专为3D资产优化，支持团队协作。"
  },
  {
      "name": "Plasmo",
      "url": "https://www.plasmo.ai/",
      "icon": "images/plasmo.png",
      "description": "草图转3D产品工具，支持工业设计流程自动化。"
  },
  {
      "name": "Kaedim",
      "url": "https://www.kaedim3d.com",
      "icon": "https://www.kaedim3d.com/favicon.ico",
      "description": "AI驱动的艺术外包平台，快速生成生产级3D模型。"
  },
  {
      "name": "Plask",
      "url": "https://plask.ai",
      "icon": "https://plask.ai/favicon.ico",
      "description": "在线AI图像生成工具，支持3D模型姿势控制，适用于概念设计。"
  },
  {
      "name": "DeepMotion",
      "url": "https://www.deepmotion.com/",
      "icon": "images/deepmotion.jpg",
      "description": "AI动作捕捉解决方案，提供实时动作数据，适用于虚拟角色动画。"
  },
  {
      "name": "Rokoko",
      "url": "https://rokoko.com",
      "icon": "images/rokoko.png",
      "description": "智能动作捕捉系统，支持全身动作实时捕捉，适用于影视和游戏开发。",
      isVpn: true
  },
  {
      "name": "Shap-E",
      "url": "https://lablab.ai/tech/openai/shap-e",
      "icon": "images/shap-e.png",
      "description": "生成隐式函数参数化3D模型的工具，支持复杂形状建模。"
  },
  {
      "name": "Move AI",
      "url": "https://move.ai",
      "icon": "images/move.png",
      "description": "便携动作捕捉方案，支持多平台数据同步，适用于远程协作。",
      isVpn: true
  },
  {
      "name": "Sloyd",
      "url": "https://sloyd.ai",
      "icon": "images/sloyd.svg",
      "description": "AI 3D模型生成器，支持语音指令建模，适用于无障碍设计。"
  },
  {
      "name": "Luma Labs",
      "url": "https://lumalabs.ai",
      "icon": "images/Luma-Labs.jpg",
      "description": "AI视频生成工具，支持文本转动态场景，适用于VR内容制作。",
      isVpn: true
  },
  {
      "name": "Text to Skybox",
      "url": "https://skybox.blockadelabs.com/",
      "icon": "images/skybox.png",
      "description": "AI生成360°无缝环境贴图工具，支持10种艺术风格，适用于游戏场景设计。"
  },
  {
      "name": "Dora AI",
      "url": "https://doraai.cn",
      "icon": "images/Dora-AI.png",
      "description": "AI动画生成平台，支持风格化3D动画，适用于艺术短片制作。"
  },
  {
      "name": "SPline AI",
      "url": "https://spline.design/ai-generate",
      "icon": "images/spline.jpg",
      "description": "AI生成3D物体/动画/材质工具，支持多格式输出，适用于广告和游戏开发。"
  },
  {
      "name": "魔音工坊",
      "url": "https://www.moyin.com/",
      "icon": "images/moyin-gongfang.png",
      "description": "AI配音工具，支持多语种和情绪调节，适用于互动媒体开发。"
  }
]

export default aiSix
